import useLanguageNavigate from '@hooks/useLanguageNavigate';
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function AddCropSection() {
	const { navigateWithLanguage } = useLanguageNavigate();
	const { t } = useTranslation();

	const handleAdd = () => {
		localStorage.removeItem('farmId');
		navigateWithLanguage('/farmer/my-farm/create');
	};

	return (
		<div className="flex flex-col justify-center items-center h-full gap-[30px]">
			<h1 className="text-dark text-center font-roboto text-xl font-bold">{t('myFarm.myFarm')}</h1>
			<p className="text-secondary text-center font-roboto text-base font-normal leading-snug">
				{t('myFarm.myFarmDescription')}
			</p>
			<Button onClick={handleAdd} variant="contained" startIcon={<AddIcon />}>
				{t('myFarm.addCrop')}
			</Button>
		</div>
	);
}
